import React from 'react';
import classes from './JSONModal.module.css';
import Modal from '../../../components/UI/Modals/Modal';
import Spinner from '../../../components/UI/Spinner/Spinner';
import { AxiosResponse } from 'axios';
import { authorizeClient } from '../../../networking/client';
import { toast } from 'react-toastify';

import POSITION = toast.POSITION;
import CustomTextField from '../../../components/UI/Inputs/CustomTextField';
import { useTranslation } from '../../../hooks/useTranslations';

type Props = {
  barcode?: string;
  onClose: () => void;
};

type ResultType = {
  result: {
    external_biomarker_request: {
      OBR: any;
      OBX: any[];
    };
  };
};

const JSONModal: React.FC<Props> = ({ barcode, onClose }) => {
  const { translations } = useTranslation();

  const [loading, setLoading] = React.useState<boolean>(true);
  const [data, setData] = React.useState<ResultType>();

  React.useEffect(() => {
    if (barcode) {
      authorizeClient
        .get(`/healthpoint/external_result_info/${encodeURI(barcode)}`)
        .then((response: AxiosResponse<ResultType>) => {
          setData(response.data);
        })
        .catch(() => {
          toast.error(translations('no.data.available'), { position: POSITION.BOTTOM_RIGHT });
          onClose();
        })
        .finally(() => setLoading(false));
    } else {
      onClose();
    }
  }, [barcode]);

  return (
    <Modal
      isOpen={!!barcode}
      onClose={onClose}
      containerPadding={'80px 30px 30px 30px'}
      width={'50%'}
      maxWidth={'700px'}
      header={translations('detailed.results').toString()}
    >
      {loading && <Spinner />}
      {!loading && data && (
        <>
          {Object.keys(data.result.external_biomarker_request.OBR).map((key) => (
            <div key={key} className={classes.row}>
              <div className={classes.rowItemLarge}>{key.replace(/_/g, ' ')}</div>
              <CustomTextField
                value={data.result.external_biomarker_request.OBR[key]}
                onChange={() => {}}
                disabled
              />
            </div>
          ))}
        </>
      )}
    </Modal>
  );
};

export { JSONModal };
